import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { DemReservePerspective } from '@/gtn/org/dem/entities/reserve/DemReservePerspective';
import { Route } from 'react-router-dom';
import { DemActualsGtnDashboard } from './entities/actualsGtn/DemActualsGtnDashboard';
import { DemForecastDetail } from './entities/forecast/DemForecastDetail';
import { DemGrossSalesPerspective } from './entities/grossSales/DemGrossSalesPerspective';
import { DemMcoPymtPerspective } from './entities/mcoPymt/DemMcoPymtPerspective';
import { DemReconPerspective } from './entities/recon/DemReconPerspective';

const demGtnRoutes = [
  <Route path="/gtn/recon" element={<EntityView perspectiveComponent={DemReconPerspective} />} />,
  <Route path="/gtn/reserve" element={<EntityView perspectiveComponent={DemReservePerspective} />} />,
  <Route path="/gtn/gross-sales" element={<EntityView perspectiveComponent={DemGrossSalesPerspective} />} />,
  <Route path="/gtn/gross-to-net" element={<DemActualsGtnDashboard />} />,
  <Route path="/gtn/mco-pymt" element={<EntityView perspectiveComponent={DemMcoPymtPerspective} />} />,
  <Route path="/gtn/forecast" element={<EntityView detailComponent={DemForecastDetail} />} />,
  <Route path="/gtn/action" element={<EntityView />} />,
  <Route path="/gtn/accr-rate" element={<EntityView />} />,
];

export default demGtnRoutes;
